import { useState } from 'react';
export function useBrandMotion() {
  const [enabled, setEnabled] = useState(() => {
    try { return window.localStorage.getItem('brand-motion') !== 'off'; }
    catch { return true; }
  });
  const toggle = () => setEnabled(previous => {
    const next = !previous;
    try { window.localStorage.setItem('brand-motion', next ? 'on' : 'off'); }
    catch { /* Pause remains usable without persistent storage. */ }
    return next;
  });
  return { enabled, toggle };
}
